import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { blue400 } from '../../ui/colors';

export interface StaticReviewStarsProps {
  // add review stars props here
  className?: string;
  color?: string;
  size?: SizeProp;
}

const StaticReviewStars: React.FC<StaticReviewStarsProps> = ({}: StaticReviewStarsProps) => (
  <div className={`text-nowrap }`}>
    <span>
      <FontAwesomeIcon
        icon={faStar}
        color='#e02d88'
        style={{ fontSize: '12px' }}
      />
    </span>{' '}
    <span>
      <FontAwesomeIcon
        icon={faStar}
        color='#e02d88'
        style={{ fontSize: '12px' }}
      />
    </span>{' '}
    <span>
      <FontAwesomeIcon
        icon={faStar}
        color='#e02d88'
        style={{ fontSize: '12px' }}
      />
    </span>{' '}
    <span>
      <FontAwesomeIcon
        icon={faStar}
        color='#e02d88'
        style={{ fontSize: '12px' }}
      />
    </span>{' '}
    <span>
      <FontAwesomeIcon
        icon={faStar}
        color='#e02d88'
        style={{ fontSize: '12px' }}
      />
    </span>
  </div>
);

export { StaticReviewStars as default };
